import React from 'react';

const AppDescription: React.FC = () => {
  return (
    <section className="bg-white rounded-xl md:rounded-2xl shadow-lg p-4 md:p-6 mb-6 md:mb-8">
      {/* <h2 className="text-xl md:text-2xl font-bold text-black mb-3 md:mb-4">Mô tả</h2> */}
      <div className="prose prose-lg max-w-none text-black">
        <p className="mb-4">
          <strong>Locuno Community Hub</strong> - Nơi kết nối cộng đồng địa phương, biến hàng xóm lạ thành người thân.
        </p>
        <p className="mb-4">
          Locuno (Location Uno) là ứng dụng cộng đồng hàng đầu tại Việt Nam, giúp bạn:
        </p>
        <ul className="list-disc list-inside mb-4 space-y-2">
          <li><strong>Kết nối hàng xóm:</strong> Gặp gỡ và làm quen với những người sống gần bạn</li>
          <li><strong>Chợ trời địa phương:</strong> Mua bán đồ cũ, thực phẩm tươi ngon từ hàng xóm</li>
          <li><strong>Sự kiện cộng đồng:</strong> Tham gia các hoạt động thú vị trong khu vực</li>
          <li><strong>Nhóm quan tâm:</strong> Tìm những người có cùng sở thích và đam mê</li>
          <li><strong>Chia sẻ thông tin:</strong> Cập nhật tin tức, thông báo quan trọng trong khu phố</li>
        </ul>
        <p className="mb-4">
          Với giao diện thân thiện và dễ sử dụng, Locuno mang đến trải nghiệm kết nối cộng đồng tuyệt vời nhất.
        </p>
        <p className="text-gray-600 text-sm">
          Hãy tải ngay để bắt đầu hành trình xây dựng cộng đồng mạnh mẽ từ cửa nhà bạn!
        </p>
      </div>
    </section>
  );
};

export default AppDescription;
